import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import LogoutIcon from '@mui/icons-material/Logout'
import {
    AppBar as MuiAppBar, Toolbar, IconButton, Avatar,
    Menu, MenuItem, Typography, Box, Divider
} from '@mui/material'
import { styled } from '@mui/system'

import Loader from '../feedbacks/Loader'
import { heroLightImage } from '../../../assets'
import { acDrawerToggle, acLogout } from '../../../store/actions'

const StyledToolbar = styled(Toolbar)(() => ({
    display: 'flex',
    justifyContent: 'space-between'
}))

const Logo = () => (
    <Box display="flex" alignItems="center" gap={1} sx={{ cursor: 'pointer' }}>
        <img
            src={heroLightImage}
            alt="4kst"
            height={32}
            onClick={() => {
                window.location.href = '/'
            }}
        />
    </Box>
)

const MyAppBar = () => {

    const dispatch = useDispatch()

    const drawerOpen = useSelector((state) => state.drawer.isOpen)
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
    const isLoadingCustomer = useSelector((state) => state.customer.isLoadingCustomer)
    const customer = useSelector((state) => state.customer.customer)

    const [anchorEl, setAnchorEl] = useState(null)

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        dispatch(acLogout())
        setAnchorEl(null)
    }

    const getInitials = (name) => {
        if (!name) return 'U'

        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)
    }

    const getDisplayName = () => {
        if (!customer) return 'Usuário'

        if (customer.first_name && customer.last_name) {
            return `${customer.first_name} ${customer.last_name}`
        }

        if (customer.name) {
            return customer.name
        }

        if (customer.first_name) {
            return customer.first_name
        }

        if (customer.username) {
            return customer.username
        }

        return 'Usuário'
    }

    const getEmail = () => {
        return customer?.email || 'email@email.com'
    }

    if (!isAuthenticated) {
        return
    }

    return (
        <MuiAppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: '#002FAD'
            }}
        >
            <StyledToolbar>
                <Box display="flex" alignItems="center">
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={() => dispatch(acDrawerToggle())}
                        sx={{ mr: 2 }}
                    >
                        {drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                    <Logo />
                </Box>

                {isLoadingCustomer ? (
                    <Loader color='secondary' />
                ) : (
                    <Box>
                        <IconButton onClick={handleMenuOpen}>
                            <Avatar sx={{ bgcolor: 'grey.500', width: 40, height: 40 }}>
                                {getInitials(getDisplayName())}
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                            <Box px={2} py={1}>
                                <Typography fontWeight={500}>
                                    {getDisplayName()}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {getEmail()}
                                </Typography>
                            </Box>
                            <Divider />
                            <MenuItem onClick={handleLogout}>
                                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                                Sair
                            </MenuItem>
                        </Menu>
                    </Box>
                )}

            </StyledToolbar>
        </MuiAppBar>
    )
}

export { MyAppBar as AppBar }